module.exports = __webpack_public_path__ + "img/img_案例01.6078dd36.png";